import AssetService from '@/services/AssetService';
import { urls } from '@/config/assets';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { getUrlBoolean } from '@/helpers/UrlParam';

export const Landing = ({ ...props }) => {
  const { t } = useTranslation();
  const page = useAppStore((state) => state.page);
  const nextPage = useAppStore((state) => state.nextPage);
  const popup = useAppStore((state) => state.popup);
  // const setPopup = useAppStore((state) => state.setPopup);

  const handleStart = () => {
    nextPage();
    AssetService.getAsset('s_button').play();
  };

  const show = page == '' || page == 'landing';

  const refRoot = useRef(null);
  const refVideo = useRef(null);
  const refLockup = useRef(null);
  const refButton = useRef(null);
  const refFooter = useRef(null);

  // const animateIn = useCallback(() => {
  //   if (refVideo.current) {
  //     refVideo.current.play();
  //   }
  // }, []);

  // useEffect(() => {
  //   if (show) {
  //     animateIn();
  //   }
  // }, [page]);

  useGSAP(
    () => {
      if (!show) return;
      if (popup) return;
      refVideo.current.play();
      let tl = gsap.timeline();
      tl.add('wait');
      tl.add('start', 'wait+=2.8');
      tl.to('.lockup', { opacity: 1 }, 'start+=0');
      tl.add(() => {
        AssetService.getAsset('s_beerfarmer').play();
      }, 'start+=0');
      tl.to('.button', { opacity: 1 }, 'start+=0.4');
      tl.to('.footer', { opacity: 1 }, 'start+=0.6');
    },
    { dependencies: [page, popup], scope: refRoot }
  );

  const muted = useAppStore((state) => state.muted);
  const ready = useAppStore((state) => state.ready);
  useEffect(() => {
    if (ready && getUrlBoolean('skipVerifyAge')) {
      handleStart();
    }
  }, [ready]);

  return (
    <div
      ref={refRoot}
      className={cn(['page', 'Landing', !show && 'hidden', 'opacity-100'])}
    >
      {/* <img
        src="assets/images-next/landing.webp"
        className="full object-cover"
      /> */}
      <video
        ref={refVideo}
        src="assets/videos/opening.mp4"
        playsInline
        className="full pointer-events-none object-cover"
        muted={!show || muted}
      />

      <div className="content full flex-center-col items-center justify-between py-5">
        <div className="top flex-center-col gap-3">
          <img
            ref={refLockup}
            src="assets/images-next/lockup.webp"
            className="lockup h-[16rem] opacity-0"
            alt={t('landing.heading')}
          />

          <div
            className="button relative w-fit opacity-0"
            ref={refButton}
          >
            <button
              className={cn(
                'btn-primary frame-brown h-[5rem] w-[24.6rem]',
                'text-[2rem] tracking-[-0.019em]'
              )}
              onClick={handleStart}
            >
              {t('landing.cta')}
            </button>

            <Loading />
          </div>
        </div>

        <img
          ref={refFooter}
          src="assets/images-next/hawkstone.webp"
          className="footer absolute bottom-[4rem] h-[2.8rem] opacity-0"
          alt={t('landing.footer')}
        />
      </div>
    </div>
  );
};
